module.exports = __webpack_public_path__ + "static/media/location.1bf568cc.svg";